export default __webpack_public_path__ + "static/media/dashboardscreen.6bc48b35.jpeg";